import React, { memo } from 'react';
import EditableCell from './EditableCell';

export default props => {
  const { prefix, suffix, ...rest } = props;
  const value = props.value && props.value.value;
  const textWidth = (props.column.getActualWidth() - 50) + 'px';

  const textStyle = {
    maxWidth: textWidth,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center'
  };

  return (
    <EditableCell gridProps={rest} wrapperClassName='grid-dropdown-cell-renderer' iconClassName='icon-pencil3 text-size-small'>
      <div style={containerStyle}>
        {value && prefix && <span className="text-muted">{prefix}</span>}
        <span style={textStyle}>{value}</span>
        {value && suffix && <span className="text-muted">{suffix}</span>}
      </div>
    </EditableCell>
  );
};
